<template>
    <div id="Page" class="Page" v-if="data">
      <div id="Top" class="Section Section_grey Section_full">

        <div class="Section_wrapper">
            <h6>OUPS</h6>
          </transition>
          <transition name="bottom" appear>
            <h2>Page introuvable</h2>
          </transition>
          <transition name="bottom" appear>
            <p><strong>Il semblerait que cette page n'existe pas.</strong></p>
          </transition>

          <transition name="fade" appear>
            <img src="../../public/static/images/page_header.png"/>
          </transition>
        </div>

      </div>

      <Footer />
    </div>
</template>

<script>
  import page from '@/mixins/page'
  import Vue from 'vue'
  import { mapActions, mapState } from 'vuex' 

  import Footer from '@/components/partials/Footer'
  import PageNav from '@/components/PageNav'
  import PageArticle from '@/components/PageArticle'

  export default {
    name: "Page",
    mixins: [ 'page' ],
    components: { Footer, PageNav, PageArticle },
    data() {
      return {
        data: null,
        nav: []
      }
    },
    beforeRouteEnter (to, from, next) {
      Vue.$api.getPage(to.params.slug)
      .then(response => {
        next(vm => vm.setData(response.data))
      })
    },
    beforeRouteUpdate (to, from, next) {
      this.$api.getPage(to.params.slug)
      .then(response => {
        next(this.setData(response.data))
      })
    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    methods: {
      ...mapActions([
        
      ]),
      setData(data)
      {
        this.data = data
        this.nav = []
        
        for (let i = 0; i < this.data.articles.length; i++) {
          const element = this.data.articles[i];

          if(element.in_nav)
          {
            this.nav.push({ to: this.$route.path + '#' + Number(i + 1), label: element.nav_name })
          }
        }
      },
    },
    mounted()
    {
      // this.$el.querySelectorAll('.Shape').forEach( el => {
      //   this.$scroll.set(el, { y: -70 }, { y: 0 }, { y: -140 }, null, -2)
      // })
    }
  }
</script>

<style lang="stylus">
.Page

  #Content

    .Section_wrapper

      padding-top 0px

    .PageArticle:last-child

      border-bottom 0px

  #Top

    z-index 2

    .Section_wrapper

      padding-bottom 100px
      padding-top 100px

      @media $small

        padding-top 40px
        padding-bottom 40px

    h2

      transition-delay 0.1s

    .Content

      transition-delay 0.2s

    a

      transition-delay 0.3s

    img

      width 100%
      margin-top 40px
      transition-delay 0.4s
</style>